exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "api-select-search md-input-container{margin:0;width:120px}api-select-search md-input-container.md-input-focused:not([md-no-float]) .md-select-placeholder span:first-child{transform:none}api-select-search label{display:none}api-select-search .select-with-searchbox md-content{margin-top:48px;padding:0;min-height:0}api-select-search .select-with-searchbox .header-searchbox{border:none;outline:none;height:100%;width:100%;padding:0}api-select-search .select-with-searchbox .select-header{box-shadow:0 1px 0 0 rgba(0,0,0,.1),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12);padding-left:10.667px;height:48px;cursor:pointer;display:flex;align-items:center;width:100%;position:fixed;top:0;left:0;right:0;background-color:#fff}api-select-search .select-with-searchbox md-content._md{max-height:240px;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/common/api-select-search/api-select-search.scss
// module id = 556
// module chunks = 0